import React from 'react';
import './SkeletonLoader.css';

const SkeletonLoader = ({ type = 'table', rows = 5, columns = 4 }) => {
    if (type === 'table') {
        return (
            <div className="skeleton-table">
                {[...Array(rows)].map((_, rowIndex) => (
                    <div key={rowIndex} className="skeleton-row">
                        {[...Array(columns)].map((_, colIndex) => (
                            <div key={colIndex} className="skeleton-cell">
                                <div className="skeleton-shimmer"></div>
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        );
    }

    if (type === 'card') {
        return (
            <div className="skeleton-card">
                <div className="skeleton-card-header">
                    <div className="skeleton-shimmer"></div>
                </div>
                <div className="skeleton-card-body">
                    <div className="skeleton-text skeleton-shimmer"></div>
                    <div className="skeleton-text skeleton-shimmer"></div>
                    <div className="skeleton-text short skeleton-shimmer"></div>
                </div>
            </div>
        );
    }

    if (type === 'list') {
        return (
            <div className="skeleton-list">
                {[...Array(rows)].map((_, index) => (
                    <div key={index} className="skeleton-list-item">
                        <div className="skeleton-avatar skeleton-shimmer"></div>
                        <div className="skeleton-list-content">
                            <div className="skeleton-text skeleton-shimmer"></div>
                            <div className="skeleton-text short skeleton-shimmer"></div>
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    // Default: single line
    return (
        <div className="skeleton-line">
            <div className="skeleton-shimmer"></div>
        </div>
    );
};

export default SkeletonLoader;
